import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arcLine",
  "use": "icon-arcLine-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arcLine\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#8FC31F\" d=\"M22.475,22.475c42.816,0,81.582,17.357,109.639,45.412\n\tc28.055,28.057,45.412,66.823,45.412,109.639h-26.479c0-35.506-14.391-67.654-37.654-90.919\n\tC90.128,63.345,57.98,48.954,22.475,48.954V22.475z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol